<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="65%"
    scrollable
    :retain-focus="false"
  >
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row align="center">
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">{{ cardTitle }}</v-col>
          <div>
            <v-tabs
              right
              v-model="activeTab"
              right
              background-color="grey lighten-3"
              ><v-tab key="details">Details</v-tab>
              <v-tab key="images">Images</v-tab>
            </v-tabs>
          </div>
        </v-row>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-tabs-items v-model="activeTab">
          <v-tab-item key="details">
            <v-layout>
              <v-flex sm12 style="position: relative">
                <v-img :src="imageURL" aspect-ratio="3" contain class="grey">
                  <v-btn text icon dark @click="onView" v-show="false">
                    <v-icon>zoom_in</v-icon>
                  </v-btn>
                  <v-row justify="end" v-if="image != ''">
                    <v-col cols="1">
                      <v-btn
                        dark
                        icon
                        @click="onImageRemove"
                        color="pink"
                        fab
                        small
                      >
                        <v-icon small>close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-img>
                <uppload-btn @uploadComplete="onUploadComplete">
                  <template slot-scope="{ on }">
                    <v-btn
                      color="pink"
                      absolute
                      bottom
                      right
                      small
                      fab
                      dark
                      @click="on"
                    >
                      <v-icon>mdi-cloud-upload</v-icon>
                    </v-btn>
                  </template>
                </uppload-btn>
              </v-flex>
            </v-layout>
            <v-container grid-list-sm>
              <v-layout wrap>
                <v-flex sm6>
                  <v-text-field
                    v-model="title"
                    label="Content Name"
                    :outlined="outlinedInputs"
                  ></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <language-select
                    @onSelect="onLanguageChange"
                    v-model="languageId"
                    :outlined="outlinedInputs"
                    forContent
                  ></language-select>
                </v-flex>
                <v-flex sm1>
                  <v-text-field
                    v-model.number="sequence"
                    type="number"
                    label="Sequence"
                    :outlined="outlinedInputs"
                  />
                </v-flex>
                <v-flex>
                  <v-checkbox
                    label="Is Default"
                    v-model="isDefault"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center align-center px-3 py-0>
                <v-flex xs12 md2>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="Reports"
                    v-model="forReports"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="Quotation"
                    v-model="forQuotation"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="Confirmation"
                    v-model="forConfirmation"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="Voucher"
                    v-model="forVoucher"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="Other"
                    v-model="forOther"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md1>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="Web"
                    v-model="forWeb"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md1>
                  <v-checkbox
                    class="pa-0 ma-0"
                    hide-details
                    label="App"
                    v-model="forApp"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <vue-editor v-model="description"></vue-editor>
          </v-tab-item>
          <v-tab-item key="images">
            <images v-model="images"></images>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <div v-if="debug">lang{{ languageId }}{{ value }}</div>
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="onClose">Cancel</v-btn>
        <v-btn
          color="secondary"
          text
          :disabled="!isValid"
          @click="onSave('saveAndNew')"
          >Save & Clear</v-btn
        >
        <v-btn
          color="secondary"
          text
          :disabled="!isValid"
          @click="onSave('saveAsNew')"
          >Save as New</v-btn
        >
        <v-btn
          color="primary"
          :disabled="!isValid"
          @click="onSave('saveAndClose')"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UpploadBtn from "./UpploadBtn";
import { VueEditor } from "vue2-editor";
import LanguageListSelect from "../../shared/LanguageListSelect";
import {
  CONTENT_UPDATE_MUTATION,
  CONTENT_CREATE_MUTATION,
} from "../../../../constants/graphql";
import { visibilityOptions } from "./visibility-options";
import Images from "../images/Images.vue";
import { removeGQLTypename } from "../../../../helpers";
const randomize = require("randomatic");
export default {
  name: "content-edit-dialog",
  props: {
    value: {
      type: Object,
    },
    show: { type: Boolean, default: () => false },
    dialogTitle: {
      type: String,
      default: () => "",
    },
  },
  components: {
    UpploadBtn,
    VueEditor,
    languageSelect: LanguageListSelect,
    Images,
  },
  data() {
    return {
      debug: false,
      activeTab: 0,
      images: this.value ? this.value.images.edges.map(removeGQLTypename) : [],
      image: this.value && this.value.imgURL ? this.value.imgURL : "",
      title: this.value && this.value.name ? this.value.name : "Content Name",
      sequence: this.value && this.value.sequence ? this.value.sequence : 0,
      description:
        this.value && this.value.description
          ? this.value.description
          : "Content Text",
      forWeb: this.value && this.value.forWeb ? this.value.forWeb : false,
      forReports:
        this.value && this.value.forReports ? this.value.forReports : false,
      forQuotation:
        this.value && this.value.forQuotation ? this.value.forQuotation : false,
      forConfirmation:
        this.value && this.value.forConfirmation
          ? this.value.forConfirmation
          : false,
      forVoucher:
        this.value && this.value.forVoucher ? this.value.forVoucher : false,
      forOther: this.value && this.value.forOther ? this.value.forOther : false,
      forApp: this.value && this.value.forApp ? this.value.forApp : false,
      isDefault:
        this.value && this.value.isDefault ? this.value.isDefault : false,
      languageId:
        this.value && this.value.language
          ? this.value.language.id
          : this.value
          ? this.$store.getters.localSettings(
              `${this.value.owner}-contents-language`,
              this.$store.getters.userConfig.defaultLanguageId
            )
          : this.$store.getters.userConfig.defaultLanguageId,
    };
  },
  methods: {
    onSave(payload) {
      const flags = visibilityOptions.reduce((result, item) => {
        //result[item.code] = this.visibility.indexOf(item.code) > -1;
        result[item.code] = this[item.code];
        return result;
      }, {});
      const content = {
        name: this.title,
        description: this.description,
        languageId: this.languageId,
        isDefault: this.isDefault,
        imgURL: this.image,
        id: this.value.id,
        ownerId: this.value.ownerId,
        owner: this.value.owner,
        sequence: this.sequence,
        ...flags,
        images: [...this.images],
      };
      //console.log("content to save", content);
      const mutation =
        this.value.id && payload != "saveAsNew"
          ? CONTENT_UPDATE_MUTATION
          : CONTENT_CREATE_MUTATION;
      this.saving = true;
      this.$apollo
        .mutate({
          mutation,
          variables: { ...content },
        })
        .then((data) => {
          this.saving = false;
          this.$emit("contentSave", payload);
        })
        .catch((error) => {
          console.error(error);
          this.saving = false;
        });
    },
    onClose() {
      this.$emit("close");
    },
    onView() {
      console.log("view full img");
    },
    onUploadComplete(payload) {
      if (payload.success) {
        this.image = payload.fileURL;
      }
    },
    onLanguageChange(payload) {
      this.languageId = payload;
    },
    onImageRemove() {
      this.image = "";
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.languageId != "" && this.title != "";
    },
    imageURL() {
      return this.image != ""
        ? this.image
        : "https://via.placeholder.com/800x600.png?text=Content%20Image";
    },
    cardTitle() {
      return this.dialogTitle ? this.dialogTitle : this.title ? this.title : "";
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.title = val.name ? val.name : "New Content";
        this.description = val.description ? val.description : "";
        this.image = val.imgURL ? val.imgURL : "";
        this.sequence = val.sequence ? val.sequence : 0;
        this.languageId = val.languageId
          ? val.languageId
          : this.$store.getters.localSettings(
              `${this.value.owner}-contents-language`,
              this.$store.getters.userConfig.defaultLanguageId
            );
        const flags = [
          "forWeb",
          "forApp",
          "forReports",
          "forQuotation",
          "forConfirmation",
          "forVoucher",
          "forOther",
          "isDefault",
        ];
        for (let flag of flags) {
          this[flag] = val[flag];
        }
        this.images = val.images ? val.images.edges.map(removeGQLTypename) : [];
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/contents/ContentEditDialog.vue